const INVOICE_INBOX_DOMAIN = 'invoices.procurify.com'
// The backend appends a random hash to keep addresses unique, so the preview
// can only show a stand-in for it.
const INBOX_ADDRESS_SUFFIX_PLACEHOLDER = '[xxxxxx]'

export const formatInboxEmailAddressPreview = (
  domain: string,
  inboxHandle: string
) => {
  const handle = inboxHandle.trim()

  return handle
    ? `${domain}-${handle}-${INBOX_ADDRESS_SUFFIX_PLACEHOLDER}@${INVOICE_INBOX_DOMAIN}`
    : ''
}
